import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import UserService from 'services/UserService';

// Get initial active merchant from localStorage if it exists
const getInitialActiveMerchant = () => {
  const savedMerchant = localStorage.getItem('activeMerchant');
  return savedMerchant ? JSON.parse(savedMerchant) : null;
};

export const initialState = {
  loading: false,
  user: {},
  activeMerchant: getInitialActiveMerchant(),
  loadingUserMerchants: false,
  userMerchants: [],
};

export const getFullMerchantData = createAsyncThunk(
  'user/getFullMerchantData',
  async () => {
    const response = await UserService.getFullMerchantData();
    return response;
  }
);

export const getUserMerchants = createAsyncThunk(
  'user/getUserMerchants',
  async () => {
    const response = await UserService.getUserMerchants();
    return response;
  }
);

export const getUser = createAsyncThunk('user/getUser', async () => {
  const response = await UserService.getUser();
  return response;
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getUserDataSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload;
    },
    setActiveMerchant: (state, action) => {
      state.activeMerchant = action.payload;
      // Save to localStorage when activeMerchant changes
      if (action.payload) {
        localStorage.setItem('activeMerchant', JSON.stringify(action.payload));
      } else {
        localStorage.removeItem('activeMerchant');
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFullMerchantData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFullMerchantData.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(getFullMerchantData.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getUserMerchants.pending, (state) => {
        state.loadingUserMerchants = true;
      })
      .addCase(getUserMerchants.fulfilled, (state, action) => {
        state.loadingUserMerchants = false;
        state.userMerchants = action.payload;
      })
      .addCase(getUserMerchants.rejected, (state, action) => {
        state.loadingUserMerchants = false;
      })
      .addCase(getUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      });
  },
});

export const { getUserDataSuccess, setActiveMerchant } = userSlice.actions;

export default userSlice.reducer;
